module.exports = __webpack_public_path__ + "static/media/reply_icon_light.9677d827.svg";